<template>
    <!-- 浏览记录 -->
    <div class="item-box">
        <div class="top-line">
            <div class="tit">浏览记录</div>
            <div class="right" v-if="active == '999' && list.length == 4">
                <el-button type="text" @click="handleCheckTab()" size="mini">
                    查看更多
                </el-button>
            </div>
        </div>
        <div class="infor-item">
            <sc-table-v2
                v-if="active == '2' || list.length"
                :head="tableHead"
                :data="list"
                :page="page"
                :page-hide="pageHide"
                :read-table="true"
                :load="load"
                :pop-show="false"
                :show-add="false"
                :table-height="tableHeightCalc"
                :selection="false"
                ref="refTable"
                @pageChange="pageChange"
                @pageSizesChange="pageSizesChange"
            >
                <template v-slot:url>
                    <el-table-column label="示意图">
                        <template slot-scope="scope">
                            <el-image
                                :src="scope.row.url"
                                :key="ind"
                                class="img"
                                fit="cover"
                                style="width: 50px; height: 50px"
                                :preview-src-list="[scope.row.url]"
                            ></el-image>
                        </template>
                    </el-table-column>
                </template>
            </sc-table-v2>
        </div>
    </div>
</template>
<script>
import { getUserBrowsingList } from '@/api/mkt/user.js';

export default {
    name: 'browse-list',
    props: {
        tabActive: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            active: '',
            load: false,
            pageHide: true,
            tableHead: [
                { name: '浏览时间', key: 'createTime' },
                { name: '内容类型', key: 'contentType' },
                { name: '示意图', key: 'url' },
                { name: '发布人', key: 'createName' },
                { name: '浏览内容', key: 'content' },
                { name: '浏览时长', key: 'browsingTimes' },
            ],
            tableHeightCalc: null,
            page: {
                size: 4,
                page: 1,
                count: 0,
            },
            list: [],
        };
    },

    watch: {
        tabActive: {
            immediate: true,
            handler(newVal) {
                this.list = [];
                this.active = newVal;
                if (newVal == '999') {
                    this.tableHeightCalc = null;
                    this.page.size = 4;
                    this.pageHide = true;
                } else if (newVal == '2') {
                    this.tableHeightCalc = window.innerHeight - 500;
                    this.page.size = 30;
                    this.pageHide = false;
                }
                if (this.$route.query.token) {
                    setTimeout(async () => {
                        this.getUserBrowsingList();
                    }, 800);
                } else {
                    this.getUserBrowsingList();
                }
            },
        },
    },
    methods: {
        async getUserBrowsingList() {
            let params = {
                page: this.page.page,
                size: this.page.size,
                accountId: this.$route.query.accountId,
            };
            this.load = true;
            let { code, data } = await getUserBrowsingList(params);
            if (code === 200) {
                this.load = false;
                data.children.forEach(ele => {
                    ele.browsingTimes = ele.browsingTime + 's';
                });
                this.list = data.children;
                this.page.count = data.total;

                data.total && this.$emit('setTabNum', { type: 2, num: data.total });
            } else {
                this.load = false;
            }
        },
        pageChange(val) {
            this.page.page = val;
            this.getUserBrowsingList();
            this.$nextTick(() => {
                this.$refs.refTable.$refs['table-box'].bodyWrapper.scrollTop = 0;
            });
        },
        pageSizesChange(val) {
            this.page.size = val;
            this.getUserBrowsingList();
        },
        // 切换tab
        handleCheckTab() {
            this.$parent.handleClick({ label: '浏览记录', name: '2' });
        },
    },
};
</script>

<style lang="less" scoped>
.item-box {
    margin-bottom: 20px;
    .top-line {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d7d7d7;
        line-height: 34px;
        .tit {
            color: #d9001b;
        }
    }
    .infor-item {
        margin-top: 10px;
    }
}
</style>
